import { State, Action, SaveStatus } from "./chat-instructions-settings.types";

export function chatInstructionsReducer(state: State, action: Action): State {
  switch (action.type) {
    case "SET_VALUE":
      if (state.isInitializing) {
        // First SET_VALUE after INITIALIZE is the editor echoing back content — use it as baseline
        return {
          ...state,
          originalValue: action.value,
          currentValue: action.value,
          isInitializing: false,
        };
      }
      return {
        ...state,
        currentValue: action.value,
        error: action.error,
        saveStatus: state.saveStatus === SaveStatus.Saved ? SaveStatus.Idle : state.saveStatus,
      };
    case "START_SAVING":
      return { ...state, saveStatus: SaveStatus.Saving };
    case "SAVE_SUCCESS":
      return {
        ...state,
        currentValue: action.value,
        originalValue: action.value,
        saveStatus: SaveStatus.Saved,
      };
    case "SAVE_ERROR":
      return { ...state, error: action.error, saveStatus: SaveStatus.Idle };
    case "CANCEL":
      return {
        ...state,
        currentValue: state.originalValue,
        error: null,
        saveStatus: SaveStatus.Idle,
      };
    case "INITIALIZE":
      return {
        ...state,
        originalValue: action.value,
        currentValue: action.value,
        saveStatus: SaveStatus.Idle,
        error: null,
        isInitializing: true,
      };
    default:
      return state;
  }
}
